import type { LearnPracticalContent } from "../practicalContent.js";

export const tsunamiContent: LearnPracticalContent = {
  th: {
    notice: [
      "แรงสั่นสะเทือนรุนแรงใกล้ชายฝั่ง หรือน้ำทะเลลดหรือเพิ่มอย่างรวดเร็วผิดปกติ อาจเป็นสัญญาณธรรมชาติ",
      "คลื่นอาจมาได้หลายระลอก และระลอกแรกอาจไม่ใหญ่ที่สุด",
      "เสียงคำรามผิดปกติจากทะเล หรือกระแสน้ำที่เปลี่ยนเร็ว เป็นเหตุให้ออกจากเขตชายฝั่งทันที",
      "ข้อความเตือนในโทรศัพท์หรือโซเชียลอาจมาช้าหรือไม่ครอบคลุม จึงต้องรู้จักสัญญาณธรรมชาติและป้ายหนีภัยของพื้นที่",
    ],
    prepare: [
      "รู้เส้นทางหนีภัยและพื้นที่สูงใกล้ตัว โดยดูป้ายและแผนของพื้นที่",
      "ตกลงจุดนัดพบที่อยู่นอกเขตชายฝั่งกับคนในครอบครัว",
      "ฝึกเดินตามเส้นทางอพยพและเผื่อแผนสำหรับเด็ก ผู้สูงอายุ ผู้พิการ และสัตว์เลี้ยง",
      "เมื่อพักโรงแรมหรือไปเที่ยวชายฝั่ง ให้ถามทางขึ้นที่สูงและจุดรวมพล ไม่พึ่งเพียงแผนที่ในโทรศัพท์",
    ],
    during: [
      "เมื่อพบสัญญาณธรรมชาติ ให้ออกจากชายฝั่งไปยังพื้นที่สูงทันที ไม่ต้องรอประกาศ",
      "ทำตามป้ายอพยพและคำสั่งของเจ้าหน้าที่ในพื้นที่",
      "อยู่บนพื้นที่ปลอดภัยและติดตามประกาศต่อเนื่อง เพราะอันตรายอาจกินเวลาหลายชั่วโมง",
      "บอกคนในกลุ่มให้ตามไปยังพื้นที่สูงโดยไม่ย้อนกลับไปหาโทรศัพท์ รถ หรือสัมภาระ",
    ],
    avoid: [
      "อย่าไปดูคลื่นหรือกลับไปเก็บของ",
      "อย่ากลับเข้าพื้นที่ชายฝั่งจนกว่าจะมีประกาศปลอดภัยจากทางการ",
      "อย่าอยู่ใกล้ชายหาด ปากแม่น้ำ คลอง หรือทางน้ำที่เชื่อมกับทะเล",
      "อย่าขับรถตามขบวนอพยพเข้าใกล้ชายฝั่งหรือจอดกีดขวางเส้นทางที่คนต้องเดินขึ้นที่สูง",
    ],
    help: [
      "แจ้งคนใกล้ตัวระหว่างเคลื่อนออก หากทำได้โดยไม่ทำให้ล่าช้า",
      "ผู้ที่ต้องการความช่วยเหลือในการเคลื่อนที่ควรใช้แผนอพยพของพื้นที่และขอเจ้าหน้าที่ช่วย",
      "หากเส้นทางปกติถูกตัดขาด ให้ทำตามป้ายหรือเจ้าหน้าที่ไปยังจุดอพยพที่ใกล้ที่สุด ไม่ย้อนกลับเข้าหาคลื่น",
      "เมื่อปลอดภัยแล้ว หากพลัดหลง ให้ใช้จุดนัดพบหรือเจ้าหน้าที่ในพื้นที่แทนการกลับลงไปค้นหาตามชายฝั่ง",
    ],
    example:
      "อยู่ที่ชายหาดแล้วรู้สึกแผ่นดินไหวแรง หรือน้ำทะเลลดผิดปกติ: เดินตามป้ายหนีภัยไปพื้นที่สูงทันที ไม่รอภาพคลื่นหรือประกาศเตือน",
    situations: [
      {
        title: "ชายหาด",
        text: "เมื่อรู้สึกแผ่นดินไหวแรงหรือเห็นน้ำเปลี่ยนผิดปกติ ให้พาเด็กและคนในกลุ่มขึ้นที่สูงทันที ไม่หยุดถ่ายภาพหรือกลับไปเอารถ",
      },
      {
        title: "โรงแรม",
        text: "เมื่อเช็กอิน ถามพนักงานเรื่องเส้นทางหนีภัยและจุดรวมพล แล้วจำวันที่ไม่ต้องพึ่งโทรศัพท์หากไฟดับหรือเครือข่ายล่ม",
      },
      {
        title: "ท่าเรือ",
        text: "ทำตามคำสั่งเจ้าหน้าที่และป้ายในพื้นที่ อย่ามองหาข้อมูลจากคลิปเก่าหรือพยายามเดินดูน้ำที่ท่าเรือ",
      },
    ],
    checklist: [
      "รู้ทางไปพื้นที่สูง",
      "จำสัญญาณธรรมชาติ",
      "จำจุดนัดพบนอกชายฝั่ง",
      "พาคนและสัตว์เลี้ยงออกโดยไม่ชักช้า",
      "รอประกาศปลอดภัยก่อนกลับ",
      "ถามเส้นทางขึ้นที่สูงเมื่อถึงที่พัก",
      "พาเด็กและผู้ช่วยเหลือออกก่อนโดยไม่ย้อนกลับ",
    ],
  },
  en: {
    notice: [
      "Strong coastal shaking or an unusual rapid fall or rise in sea level can be a natural warning.",
      "Several waves may arrive, and the first may not be the largest.",
      "An unusual roar from the sea or rapidly changing currents is a reason to leave the coastal hazard zone immediately.",
      "Phone or social-media alerts can be late or incomplete, so know natural warnings and the local evacuation signs.",
    ],
    prepare: [
      "Learn the signed local evacuation route and nearby higher ground.",
      "Agree on a household meeting point away from the coast.",
      "Practise the evacuation route and plan assistance for children, older people, disabled people, and pets.",
      "At a hotel or coastal attraction, ask where higher ground and the meeting point are; do not rely only on a phone map.",
    ],
    during: [
      "If you notice a natural warning, leave the coast for higher ground immediately; do not wait for an alert.",
      "Follow local evacuation signs and authority instructions.",
      "Remain in the safe area and keep following updates because dangerous waves and currents may continue for hours.",
      "Tell your group to move toward higher ground without turning back for phones, vehicles, or belongings.",
    ],
    avoid: [
      "Do not approach the shore to watch the water or collect belongings.",
      "Do not return until authorities issue an all-clear.",
      "Stay away from beaches, river mouths, canals, and waterways connected to the sea.",
      "Do not drive with an evacuation flow toward the coast or park in a way that blocks people walking uphill.",
    ],
    help: [
      "Alert people nearby while leaving if this does not delay evacuation.",
      "People needing mobility assistance should use the local evacuation plan and seek official help.",
      "If the usual route is blocked, follow signs or responders to the nearest evacuation place; do not turn back toward the water.",
      "Once safe, use the meeting point or local staff if separated instead of returning down to the shore to search.",
    ],
    example:
      "You feel strong shaking on a beach or see the sea retreat unusually fast: follow evacuation signs to higher ground at once. Do not wait to see a wave or receive an alert.",
    situations: [
      {
        title: "Beach",
        text: "After strong shaking or unusual water movement, take children and companions uphill immediately. Do not stop for photos or return for a vehicle.",
      },
      {
        title: "Hotel",
        text: "At check-in, ask staff about the evacuation route and meeting point, and remember it without relying only on a phone if power or mobile service fails.",
      },
      {
        title: "Pier",
        text: "Follow local staff and signs. Do not depend on old clips or go to the waterfront to inspect the water.",
      },
    ],
    checklist: [
      "Know the route uphill",
      "Recognise natural warnings",
      "Agree on a meeting point inland",
      "Move people and pets without delay",
      "Wait for an official all-clear",
      "Ask for the route uphill at accommodation",
      "Move dependants without turning back",
    ],
  },
};
